import { useEffect, useState } from 'react';

export function useBreakpoint(width: number) {
  const [value, setValue] = useState(false);

  useEffect(() => {
    const check = () => {
      setValue(window.innerWidth >= width);
    };

    // Initial check
    check();

    // Add event listener
    window.addEventListener('resize', check);

    // Clean up
    return () => {
      window.removeEventListener('resize', check);
    };
  }, [width]);

  return value;
}
